import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-lg shadow-sm border border-gray-100">
        <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-8 text-center">Last Updated: August 20, 2026</p>

        <div className="space-y-6 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Information We Collect</h2>
            <p className="mb-2">We collect information necessary to provide you with property solutions and professional connections. This includes:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Personal Information:</strong> Name, mobile number, and user role.</li>
              <li><strong>Property Data:</strong> Survey numbers, locations, dimensions, and property types.</li>
              <li><strong>Media:</strong> Uploaded documentation and property photos.</li>
              <li><strong>Professional Data:</strong> Experience, certificates, and awards (for registered professionals).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">2. How We Use Your Information</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>To fulfill service inquiries, such as valuation reports or legal scrutiny requests.</li>
              <li>To list properties for sale in your designated area.</li>
              <li>To send relevant push notifications regarding assignments, status updates, or platform announcements.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Information Sharing and Disclosure</h2>
            <p>
              Your personal contact information and necessary property details are shared <strong>only</strong> with the specific assigned local professional (Agent, Valuer, or Engineer) required to fulfill your service request. Your personal information will not be sold to third parties without your explicit consent.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Data Security</h2>
            <p>
              We implement industry-standard security measures to protect your data. Uploaded documentation and photos are encrypted and securely stored in cloud infrastructure (AWS S3). However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Contact Us</h2>
            <p>
              If you have any questions or concerns regarding this Privacy Policy or how your data is handled, please contact our support team at support@iassets.in.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;